module.exports = __webpack_public_path__ + "img/8_001.2fca480b.webp";